import {
	SET_KPI_DASHBOARD
} from "../../actions/DashboardDesigner/actionContants";

const kpiDashboards = (state = [], action) => {
	switch (action.type) {
		case SET_KPI_DASHBOARD:
			return action.data;
		
		default:
			return state;
	}
};

export default kpiDashboards;
